export const BRIEFING_IMAGES = {
  allEvSales:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035752/assets/briefing-images/Hero_Card_-_Briefings_logz1w.jpg',
  automakerLeagueTables:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035755/assets/briefing-images/Hero_Card_-_Briefings-1_qx2zm1.jpg',
  batterySnapshots:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035754/assets/briefing-images/Hero_Card_-_Briefings-2_efhoqe.jpg',
  batteryMineralsSnapshots:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035754/assets/briefing-images/Hero_Card_-_Briefings-3_do5xvg.jpg',
  inventoryTrackers:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035754/assets/briefing-images/Hero_Card_-_Briefings-4_gqmyy3.jpg',
  rawMaterialPrices:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035755/assets/briefing-images/Hero_Card_-_Briefings-5_c0omay.jpg',
  supplyChainCapitalTrackers:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035752/assets/briefing-images/Hero_Card_-_Briefings-6_fut1yy.jpg',
  profitabilityHeatmaps:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035758/assets/briefing-images/Hero_Card_-_Briefings-7_qxbmjv.jpg',
  energyTransitionCapitals:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035753/assets/briefing-images/Hero_Card_-_Briefings-8_f56ft1.jpg',
  energyIndicators:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035752/assets/briefing-images/Hero_Card_-_Briefings-9_gvhjkb.jpg',
  eu2025VehicleEmissions:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035757/assets/briefing-images/Hero_Card_-_Briefings-10_xirkx1.jpg',
  geoEconomicAndPolicyBriefings:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035753/assets/briefing-images/Hero_Card_-_Briefings-11_az3uv5.jpg',
  regionalSnapshots:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035756/assets/briefing-images/Hero_Card_-_Briefings-12_kj2gk0.jpg',
  chinaBriefings:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035756/assets/briefing-images/Hero_Card_-_Briefings-13_mklhhv.jpg',
  sustainabilityBriefings:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035756/assets/briefing-images/Hero_Card_-_Briefings-14_ii4fgf.jpg',
  countryRiskSnapshots:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,w_600,c_fill/v1748035753/assets/briefing-images/Hero_Card_-_Briefings-15_m5aimt.jpg',
}

export const BRIEFING_POST_TYPE_SINGULAR_NAMES = {
  allEvSales: 'evSales',
  automakerLeagueTables: 'automakerLeagueTable',
  batterySnapshots: 'batterySnapshot',
  batteryMineralsSnapshots: 'batteryMineralsSnapshot',
  inventoryTrackers: 'inventoryTracker',
  rawMaterialPrices: 'rawMaterialPrice',
  supplyChainCapitalTrackers: 'supplyChainCapitalTracker',
  profitabilityHeatmaps: 'profitabilityHeatmap',
  energyTransitionCapitals: 'energyTransitionCapital',
  energyIndicators: 'energyIndicator',
  eu2025VehicleEmissions: 'eu2025VehicleEmission',
  geoEconomicAndPolicyBriefings: 'geoEconomicAndPolicyBriefing',
  regionalSnapshots: 'regionalSnapshot',
  chinaBriefings: 'chinaBriefing',
  sustainabilityBriefings: 'sustainabilityBriefing',
  countryRiskSnapshots: 'countryRiskSnapshot',
}

export const BRIEFING_ARCHIVE_TITLES = {
  EvSales: 'EV Sales',
  AutomakerLeagueTable: 'Automaker League Table',
  BatterySnapshot: 'Battery Snapshot',
  BatteryMineralsSnapshot: 'Battery Minerals Snapshot',
  InventoryTracker: 'Inventory Tracker',
  RawMaterialPrice: 'Raw Material Prices',
  SupplyChainCapitalTracker: 'Supply Chain Capital Tracker',
  ProfitabilityHeatmap: 'Profitability Heatmaps',
  EnergyTransitionCapital: 'Energy Transition Capital',
  EnergyIndicator: 'Energy Indicators',
  Eu2025VehicleEmission: 'EU 2025 Vehicle Emissions',
  GeoEconomicAndPolicyBriefing: 'Geo-Economic and Policy Briefing',
  RegionalSnapshot: 'Regional Snapshots',
  ChinaBriefing: 'China Briefing',
  SustainabilityBriefing: 'Sustainability Briefing',
  CountryRiskSnapshot: 'Country Risk Snapshots',
}
